<template>
    <div class="select-user-picker">

        <div>
            <button type="button"
                    class="btn text"
                    @click="showSelector"
            ><span class="fa fa-exchange"></span> {{ label }}
            </button>
        </div>


        <!-- Modal -->
        <div ref="picker"
             class="modal fade select-user-picker-modal"
             role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Select User</h4>
                    </div>
                    <div class="modal-body">
                        <div class="modal-subheader">
                            <input type="text" class="form-control" v-model="userFilter" ref="filter"
                                   placeholder="Search for email or last name"/>
                        </div>

                        <div class="modal-scroll-area">
                            <visible-user-list
                                    ref="list"
                                    :filter="userFilter"
                                    :includeAdmin="true"
                                    @select="select"
                            ></visible-user-list>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><span
                                class="fa fa-times"></span> Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .select-user-picker {
        display: inline-block;

        .text {
            background: transparent;
            cursor: pointer;
            border: none;
            padding: 0px;
        }
    }

    .select-user-picker-modal .modal-body > *:first-child {
        border-top: 1px solid $border-gray;
        border-bottom: 1px solid $border-gray;
        max-height: 300px;
        overflow: auto;
    }

    .select-user-picker-search {
        padding: 20px;
        background-color: #f8f9fb;
        border-bottom: 1px solid #f1f1f1;
    }

</style>

<script>
    export default {
        props: {
            type: { default: 'text' },
            label: { default: 'Select User' }
        },

        data: function() {
            return {
                picker: null,
                userFilter: ''
            }
        },

        methods: {
            showSelector: function() {
                this.picker.modal('show');
                setTimeout(this.setFocus,250);
            },

            setFocus: function() {
                this.$refs.filter.select();
            },

            select: function(user_id, first_nm, last_nm, email) {
                this.$emit('select_user', user_id, first_nm, last_nm, email);
                this.picker.modal('hide');
            }
        },

        mounted: function() {
            this.picker = $(this.$refs.picker);
            $('body').append(this.picker);
        }
    }



</script>



// WEBPACK FOOTER //
// select-user-picker.vue?195621b0